// @ts-nocheck
import { FieldLabel, inputClass } from "./SectionWrapper";

interface Props {
  value: string | null | undefined;
  onChange: (v: string) => void;
}

const MAX = 200;

export function ShortDescriptionField({ value, onChange }: Props) {
  const v = value || "";
  return (
    <div>
      <FieldLabel>Short Description</FieldLabel>
      <p className="text-xs text-muted-foreground -mt-1 mb-2">
        1-3 sentences shown as preview text on the public event page tile. Plain text only — no formatting.
      </p>
      <textarea
        value={v}
        onChange={(e) => onChange(e.target.value.slice(0, MAX))}
        maxLength={MAX}
        rows={3}
        className={inputClass + " resize-y"}
      />
      <p className="text-xs text-muted-foreground mt-1">{v.length} / {MAX}</p>
    </div>
  );
}
